import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import { InputComponent } from 'components/common/Input';
import { INPUT_TYPE, LABEL_TYPE } from 'components/common/Input/types';
import ErrorContainer from 'components/ErrorContainer';
import { Form, Formik } from 'formik';
import { useQueryParams } from 'hooks/useQueryParams';
// import TwitterOutlined from '@ant-design/icons/lib/icons/TwitterOutlined';
// import GithubOutlined from '@ant-design/icons/lib/icons/GithubOutlined';
// import FacebookOutlined from '@ant-design/icons/lib/icons/FacebookOutlined';
// import GoogleOutlined from '@ant-design/icons/lib/icons/GoogleOutlined';
import React, { useCallback, useState } from 'react';
// import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { AuthAction } from 'redux/actions';
import { RootState } from 'redux/types';
import ROUTES from 'routes/routeConstants';
// import { GET_SINGLE_USER } from 'services/graphql/queries/user.query';
// import { IUser } from 'types/user';
import IntlMessages from 'utils/IntlMessages';
import * as Yup from 'yup';

import { ActionButtonContainer, ForgotPasswordContainerStyled } from './styled';

const { userSignIn } = AuthAction;

const SignInSchema = Yup.object({
  email: Yup.string().email('Invalid Email').required('Required'),
  password: Yup.string().required('Required'),
});

const SignInFormContent: React.FC = () => {
  const dispatch = useDispatch();
  const { isSigningIn } = useSelector<RootState, RootState['auth']>(({ auth }) => auth);
  const [error, setError] = useState('');
  const history = useHistory();
  // const intl = useIntl();
  const queryParams = useQueryParams();

  const onError = useCallback((err: any) => {
    let newError = '';
    if (err.message === 'error.user_not_found') {
      newError = 'Wrong username/password';
    }
    if (err.message === 'error.user_disabled') {
      newError = 'User is disabled. Please contact admin!';
    }
    if (err.message === 'error.no_location_assigned') {
      newError =
        'You have no assigned permissions for your company.  Please contact an administrator for your to add permissions for your account.';
    }
    setError(newError);
  }, []);

  const onSuccess = () => {
    // apolloClient.writeQuery({
    //   query: GET_SINGLE_USER,
    //   variables: {
    //     id: user.id,
    //   },
    //   data: {
    //     findOneUserEntity: {
    //       __typename: 'User',
    //       ...user,
    //     },
    //   },
    // });
    // // console.log(
    // //   apolloClient.readQuery({
    // //     query: GET_SINGLE_USER,
    // //     variables: {
    // //       id: user.id,
    // //     },
    // //   }),
    // // );
    const redirect = queryParams.get('redirect');
    history.push(redirect || '/');
  };

  const onFinish = (values: { email: string; password: string; rememberMe: boolean }) => {
    dispatch(
      userSignIn({
        email: values.email,
        password: values.password,
        rememberMe: values.rememberMe || true,
        callback: { callbackOnFailure: onError, callbackOnSuccess: onSuccess },
      }),
    );
  };

  return (
    <>
      <div className='gx-app-login-content'>
        <Formik
          initialValues={{ email: '', password: '', rememberMe: true }}
          name='basic'
          onSubmit={onFinish}
          validationSchema={SignInSchema}
          validateOnBlur>
          <Form className='gx-signin-form gx-form-row0'>
            <InputComponent
              type={INPUT_TYPE.EMAIL}
              name={INPUT_TYPE.EMAIL}
              label='Email'
              labelType={LABEL_TYPE.above}
            />
            <InputComponent
              type={INPUT_TYPE.PASSWORD}
              name={INPUT_TYPE.PASSWORD}
              label='Password'
              labelType={LABEL_TYPE.above}
            />
            <ForgotPasswordContainerStyled>
              <Link to={ROUTES.RESET_PASSWORD}>Forgot password?</Link>
            </ForgotPasswordContainerStyled>
            {/* <InputComponent
              style={{ marginTop: 10 }}
              labelType={LABEL_TYPE.right}
              label={intl.formatMessage({ id: 'appModule.rememberMe' })}
              name='rememberMe'
              type={INPUT_TYPE.CHECKBOX}
            /> */}
            <ActionButtonContainer marginTop='0'>
              <ButtonWithSpinner width='80px' htmlType='submit' isLoading={isSigningIn}>
                <IntlMessages id='app.userAuth.signIn' />
              </ButtonWithSpinner>
              {/* <OrTextContainerStyled>
                <IntlMessages id='app.userAuth.or' />
              </OrTextContainerStyled>
              <Link to={ROUTES.SIGN_UP}>
                <IntlMessages id='app.userAuth.signUp' />
              </Link> */}
            </ActionButtonContainer>
            {/* <div className='gx-flex-row gx-justify-content-between'>
                  <span>or connect with</span>
                  <ul className='gx-social-link'>
                    <li>
                      <GoogleOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <FacebookOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <GithubOutlined onClick={() => {}} />
                    </li>
                    <li>
                      <TwitterOutlined onClick={() => {}} />
                    </li>
                  </ul>
                </div>
                <span className='gx-text-light gx-fs-sm'>
                  {' '}
                  demo user email: &apos;demo@example.com&apos; and password: &apos;demo#123&apos;
                </span> */}
          </Form>
        </Formik>
        {error && (
          <ErrorContainer>
            <span>{error}</span>
          </ErrorContainer>
        )}
      </div>
    </>
  );
};

export default SignInFormContent;
